import { clientAxios } from '@/plugins/axios'
const baseUrl = '/v1/line/advertisement/tracking'

export const trackingPermission = (body) => clientAxios.post(baseUrl, body)

export const postAdv = (body) => clientAxios.post(`${baseUrl}/add-friend`, body)
